export const zIndexTokens = {
  base: 0,
  dropdown: 1000,
  sticky: 1100,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
} as const;

export type ZIndexTokenName = keyof typeof zIndexTokens;
